import {
    MarkovRedistributionStateFrom,
    MarkovRedistributionStateTo,
    MarkovState,
} from "server/models"
import { OrderType } from "client/utils"
import { MarkovStateFilters } from "client/store"

export interface MarkovRedistributionStateProps {
    stateId: number
}

export interface MarkovRedistributionStateFromList { [stateId: number]: MarkovRedistributionStateFrom }
export interface MarkovRedistributionStateToList { [stateId: number]: MarkovRedistributionStateTo }

export type MarkovRedistributionStateFromValidation = { [key in keyof MarkovRedistributionStateFrom]?: string}
export type MarkovRedistributionStateToValidation = { [key in keyof MarkovRedistributionStateTo]?: string}

export interface MarkovRedistributionStateCalculated { [stateId: number]: number | string }

export interface MarkovRedistributionStateState {
    from: {
        stateList: MarkovRedistributionStateFromList
        stateIds: readonly number[]
        stateEdit: MarkovRedistributionStateFrom

        calculatedExpressions: MarkovRedistributionStateCalculated

        sortColumn: keyof MarkovState
        sortOrder: OrderType
        filters: MarkovStateFilters

        reloadList: boolean
        reloadEdit: boolean
    }
    to: {
        stateList: MarkovRedistributionStateToList
        stateIds: readonly number[]
        stateEdit: MarkovRedistributionStateTo

        calculatedExpressions: MarkovRedistributionStateCalculated

        sortColumn: keyof MarkovState
        sortOrder: OrderType
        filters: MarkovStateFilters

        reloadList: boolean
        reloadEdit: boolean
    }
}

// state from

export const MARKOV_REDISTRIBUTION_STATE_FROM_LIST = "MARKOV_REDISTRIBUTION_STATE_FROM_LIST"
export const MARKOV_REDISTRIBUTION_STATE_FROM_IDS = "MARKOV_REDISTRIBUTION_STATE_FROM_IDS"
export const MARKOV_REDISTRIBUTION_STATE_FROM_EDIT = "MARKOV_REDISTRIBUTION_STATE_FROM_EDIT"

export const MARKOV_REDISTRIBUTION_STATE_FROM_CALCULATED_EXPRESSIONS = "MARKOV_REDISTRIBUTION_STATE_FROM_CALCULATED_EXPRESSIONS"

export const MARKOV_REDISTRIBUTION_STATE_FROM_SORT = "MARKOV_REDISTRIBUTION_STATE_FROM_SORT"
export const MARKOV_REDISTRIBUTION_STATE_FROM_FILTERS = "MARKOV_REDISTRIBUTION_STATE_FROM_FILTERS"

export const MARKOV_REDISTRIBUTION_STATE_FROM_RELOAD_LIST = "MARKOV_REDISTRIBUTION_STATE_FROM_RELOAD_LIST"
export const MARKOV_REDISTRIBUTION_STATE_FROM_RELOAD_EDIT = "MARKOV_REDISTRIBUTION_STATE_FROM_RELOAD_EDIT"

// state to

export const MARKOV_REDISTRIBUTION_STATE_TO_LIST = "MARKOV_REDISTRIBUTION_STATE_TO_LIST"
export const MARKOV_REDISTRIBUTION_STATE_TO_IDS = "MARKOV_REDISTRIBUTION_STATE_TO_IDS"
export const MARKOV_REDISTRIBUTION_STATE_TO_EDIT = "MARKOV_REDISTRIBUTION_STATE_TO_EDIT"

export const MARKOV_REDISTRIBUTION_STATE_TO_CALCULATED_EXPRESSIONS = "MARKOV_REDISTRIBUTION_STATE_TO_CALCULATED_EXPRESSIONS"

export const MARKOV_REDISTRIBUTION_STATE_TO_SORT = "MARKOV_REDISTRIBUTION_STATE_TO_SORT"
export const MARKOV_REDISTRIBUTION_STATE_TO_FILTERS = "MARKOV_REDISTRIBUTION_STATE_TO_FILTERS"

export const MARKOV_REDISTRIBUTION_STATE_TO_RELOAD_LIST = "MARKOV_REDISTRIBUTION_STATE_TO_RELOAD_LIST"
export const MARKOV_REDISTRIBUTION_STATE_TO_RELOAD_EDIT = "MARKOV_REDISTRIBUTION_STATE_TO_RELOAD_EDIT"
